export default __webpack_public_path__ + "static/thrive-logo-63b1fe9b26f97444c89e06afca31cfce.png";